import { useEffect, useRef } from "react";

export const TrustpilotWidget = () => {
    const ref = useRef(null);
    const initialised = useRef(false);
    useEffect(() => {
        const element = ref.current;
        if (!element || initialised.current) return;
        let disposed = false;
        let timer;
        let attempts = 0;
        let apiAttempts = 0;
        let resizeObserver;
        const scripts = Array.from(document.querySelectorAll('script[src*="widget.trustpilot.com/bootstrap/"]'));

        const stopMonitoring = () => {
            window.clearTimeout(timer);
            resizeObserver?.disconnect();
            window.removeEventListener("resize", initialiseWhenReady);
            window.removeEventListener("pageshow", initialiseWhenReady);
            document.removeEventListener("visibilitychange", initialiseWhenReady);
            scripts.forEach((script) => script.removeEventListener("load", initialiseWhenReady));
        };
        function initialiseWhenReady() {
            if (disposed || initialised.current || apiAttempts >= 3 || document.hidden) return;
            if (typeof window.Trustpilot?.loadFromElement !== "function") return;
            const bounds = element.getBoundingClientRect();
            const visibility = window.getComputedStyle(element).visibility;
            if (bounds.width <= 0 || bounds.height <= 0 || visibility === "hidden" || visibility === "collapse") return;
            // Each desktop/mobile copy is initialised once, after it has a layout.
            // A successful API call does not guarantee third-party content loads.
            initialised.current = true;
            apiAttempts += 1;
            try {
                window.Trustpilot.loadFromElement(element, true);
                stopMonitoring();
            } catch (error) {
                initialised.current = false;
                if (apiAttempts >= 3) stopMonitoring();
            }
        }
        function poll() {
            if (disposed || initialised.current || apiAttempts >= 3) return;
            initialiseWhenReady();
            // Bound polling; the existing bootstrap's load event and visibility
            // observers still handle a later script load or breakpoint change.
            attempts += 1;
            if (!initialised.current && apiAttempts < 3 && attempts < 120) timer = window.setTimeout(poll, 250);
        }
        window.addEventListener("resize", initialiseWhenReady);
        window.addEventListener("pageshow", initialiseWhenReady);
        document.addEventListener("visibilitychange", initialiseWhenReady);
        scripts.forEach((script) => script.addEventListener("load", initialiseWhenReady));
        if (window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver(initialiseWhenReady);
            resizeObserver.observe(element);
        }
        poll();
        return () => {
            disposed = true;
            stopMonitoring();
        };
    }, []);

    return (
        <div style={{ width: "100%", minWidth: 0, flexShrink: 0 }}>
          <div
            ref={ref}
            className="trustpilot-widget"
            style={{ width: "100%", minHeight: "150px", flexShrink: 0 }}
            data-locale="en-GB"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="624b698e8a92c7df7ab8c9a9"
            data-style-height="150px"
            data-style-width="100%">

            <a
                href="https://uk.trustpilot.com/review/skillstg.co.uk"
                target="_blank"
                rel="noopener">Trustpilot</a>
          </div>
        </div>
    );
};
